import _noop from 'lodash/noop';
import { type JSX, useCallback, useContext } from 'react';
import { InterfaceAppStoreContext } from '../../stores/InterfaceStore/context';
import { usePageCtaAction } from './hooks/usePageCtaAction';
import type { PageCta } from './types';

type Props = {
  cta: PageCta;
  children: ({ onClick }: { onClick: () => void }) => JSX.Element;
};

function PageCtaActionProvider({ cta, children }: Props) {
  const onClick = usePageCtaAction();

  const handleClick = useCallback(() => {
    onClick({ cta });
  }, [onClick, cta]);

  return children({ onClick: handleClick });
}

function PageCtaActionProviderContainer(props: Props) {
  const _useStore = useContext(InterfaceAppStoreContext);

  /**
   * CTA won't work if notification is sent to platform with cta of type page(unexpected scenario).
   * Hence, don't wrap PageCtaActionProvider in such a case, so that notification is at least rendered.
   * Safe check in case when cta of type page was added by any other means than the notification node config in automations.
   * It is not possible to add cta of type page from the notification node config in automations unless applicationId is selected.
   * If applicationId is selected, then it means that notification will go to a LC app and hence PageCtaActionProvider will be opened in a LC context.
   */
  if (!_useStore) {
    return props.children({ onClick: _noop });
  }

  return <PageCtaActionProvider {...props} />;
}

export { PageCtaActionProviderContainer as PageCtaActionProvider };
